import React from "react";
import { Container, Row } from "react-bootstrap";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import EvaluationResultLabelForm from 'presentation/pages/evaluation-result-labels/elements/form';

import {
  mountItems
} from 'presentation/pages/evaluation-result-labels/functions/evaluation-result-label-terms';


class EvaluationResultLabelAdd extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      form: {},
      evaluationResultLabelTerms: [],
      totalItems: 1,
      actionLoading: false,
      error: false,
      message: '',
      data: [],
    };
  }

  componentDidMount() {
    mountItems(this);
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  render() {
    let { loading, error, message, actionLoading, form } = this.state;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <EvaluationResultLabelForm
                loading={loading}
                form={form}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default EvaluationResultLabelAdd;
